
import { toggleRightDrawer , setReRender} from "../../../store/global/actions"
import { useDispatch } from 'react-redux';
import { Grid, Typography, Divider, Box } from '@material-ui/core';
import { marginBottom } from "../../../config/styles";
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import React, { Fragment } from 'react';


export default function DatabaseSchemaValidation({onClose, messagesList}) {

    const onProceed = () => {
        onClose();
    }

    const messageNames = messagesList?.length === 1 ? messagesList[0]?.name : messagesList?.map(item => item?.name)?.join(", ") 


    return (
        <>
            <Grid container direction={"row"} spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" >Platform Schema Validation</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid
                    item
                    xs={12}
                    style={{
                    marginBottom: marginBottom,
                    marginTop: "5px",
                    marginLeft: "20px",
                    }}
                >
                    <Box mb={2}>
                    <Typography>
                        {`${messagesList?.length > 1 ? "Event Types" : "Event Type"} ${messageNames} ${
                        messagesList?.length > 0 ? "are" : "is"
                        } already defined in platform schema`}
                    </Typography>
                    </Box>

                    <Box mb={2}>
                    <Typography>
                        {`Please rename the ${
                        messagesList?.length > 1 ? "event types" : "event type"
                        } to avoid conflicts `}
                    </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <DeleteCancel onCancel={onClose} showCancel={false} onDelete={onProceed}  content={'OK'} />
                </Grid>

            </Grid>
        </>
    )
}
